import { render } from "./booking-cancelled.vue?vue&type=template&id=2786d09b"
import script from "./booking-cancelled.vue?vue&type=script&lang=js"
export * from "./booking-cancelled.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__